import { Observable } from 'rxjs';

import type {
  PaymentsDashboardData,
  PaymentsDashboardQuery,
} from '@app/domain/models/payments-dashboard/payments-dashboard.model';

/**
 * Port del dashboard de la Pasarela de Pagos (`GET /api/v1/payments/dashboard/`).
 *
 * Un solo método a propósito (§SOLID-I): "Todo" lo consume y no necesita nada
 * más. Los links y QR recientes NO van acá: ya tienen sus ports
 * (`PolipayPaymentsRepository`, `PaymentQrRepository`).
 *
 * Contrato de error: toda implementación falla con `PaymentsDashboardError`,
 * nunca con un `HttpErrorResponse` ni con el cuerpo del backend.
 */
export abstract class PaymentsDashboardRepository {
  abstract getDashboard(query: PaymentsDashboardQuery): Observable<PaymentsDashboardData>;
}
